import { createSlice } from "@reduxjs/toolkit";

import { Sector } from "../../../../../services";
import { ReduxReducer } from "../../../../interface";
import { GlobalState } from "../../interface";

import { State } from "./interface";

const initialState: State = {
	subscription: {
		basic: [],
	},
};

const setSubscriptionBasicData: ReduxReducer<State, Sector.Model[]> = (
	state,
	action,
) => {
	state.subscription.basic = action.payload;
};

const reset: ReduxReducer<State, any> = (state) => {
	Object.keys(initialState).forEach((key) => {
		state[key] = initialState[key];
	});
};

const globalStateCarSectorsData = createSlice({
	name: GlobalState.ConstantGlobalStateSlice.CAR_SECTORS_DATA,
	initialState,
	reducers: {
		reset,
		setSubscriptionBasicData,
	},
});

export const globalStateCarSectorsDataAction =
	globalStateCarSectorsData.actions;
export const globalStateCarSectorsDataReducer =
	globalStateCarSectorsData.reducer;
export type globalStateCarSectorsDataState = State;

export default globalStateCarSectorsData;
